module.exports = __webpack_public_path__ + "811279f936ab108de3792f4ba1105660.jpg";